import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormFeedback,
  Input,
  Label,
  Row,
  Table,
  UncontrolledTooltip
} from "reactstrap";
import * as Yup from "yup";

import Select from "react-select";

import ToastDialog from "components/Common/ToastDialog";
import "./style.scss";

// Import Breadcrumb
// redux
import { getDropDownList } from "http/fundLync/dropdown.helper";
import {
  addBorrowing,
  editBorrowing,
  getBorrowingList,
} from "http/fundLync/entityAndAddress.helper";
import { decryptedValue, formatNumberToCrores, isPermission } from "common/utility";
import { callBankList, callfinListSummary } from "http/fundLync/common.helper";
import { useAsyncDebounce } from "react-table";
import { callGetProveBaseApi } from "http/fundLync/entityDocuments.helper";

// TableRow Component
const TableRow = ({ onDelete, onItemSelect, index, validation, lenderOptions, bankValueChange }) => {
  const [borrowingProfileType, setBorrowingProfileType] = useState([]);

  useEffect(() => {
    const fetchBorrowingProfileTypes = async () => {
      try {
        const response = await getDropDownList({ dropdownName: "borrowingProfile" });
        const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName === "borrowingProfile")?.dropdownValues || [];
        setBorrowingProfileType(dropdownValues);
      } catch (error) {
        console.log("Error fetching borrowing profile types:", error);
      }
    };

    fetchBorrowingProfileTypes();
  }, []);

  const handleInputChange = (index, field, value, label) => {
    validation.setFieldValue(`lenderList.${index}.${field}`, value);
    if (field === "lenderName") {
      validation.setFieldValue(`lenderList[${index}].lenderName`, value);
  validation.setFieldValue(`lenderList[${index}].lenderLabel`, label);
    }
  };

  const setBorrowingType = (data, borrowingType) => {
    if (borrowingType) {
      const selectedOption = data.find(item => item.dropdownValue === borrowingType);
      return selectedOption ? { label: selectedOption.displayName, value: borrowingType } : null;
    }
    return null;
  };

  const getSelectedLenderOption = (options, lenderName) => {
    if (lenderName) {
      const selectedOption = options.find(option => option.value === lenderName);
      return selectedOption ? { label: selectedOption.label, value: lenderName } : null;
    }
    return null;
  };
  return (
    <tr>
    <td data-label="Lender *">
        <div className="d-flex flex-column">
          <Select
            options={lenderOptions}
            className={`${validation.touched.lenderList?.[index]?.lenderName &&
              validation.errors.lenderList?.[index]?.lenderName
              ? "is-invalid"
              : ""
            }`}
            name={`lender[${index}].name`}
            id={`lender[${index}].name`}
            onChange={(selectedOption) => {
              handleInputChange(index, "lenderName", selectedOption.value, selectedOption.label);
            }}
            value={getSelectedLenderOption(lenderOptions, validation.values.lenderList[index]?.lenderName)}
            onKeyDown={(e) => {
              bankValueChange(e.target.value);
            }}
            placeholder="Select Lender"
          />
          {validation.touched.lenderList?.[index]?.lenderName &&
            validation.errors.lenderList?.[index]?.lenderName && (
              <FormFeedback>
                {validation.errors.lenderList[index].lenderName}
              </FormFeedback>
            )}
        </div>
      </td>
      <td data-label="Type *">
        <div className="d-flex flex-column">
          <Select
            options={borrowingProfileType.map((option) => ({
              label: option.displayName,
              value: option.dropdownValue,
            }))}
            className={`${validation.touched.lenderList?.[index]?.type &&
              validation.errors.lenderList?.[index]?.type
              ? "is-invalid"
              : ""
            }`}
            name={`lender[${index}].type`}
            id={`lender[${index}].type`}
            onChange={(selectedOption) => {
              handleInputChange(index, "type", selectedOption.value);
            }}
            value={setBorrowingType(borrowingProfileType, validation.values.lenderList[index].type)}
            placeholder="Select Type ...  "
          />
          {validation.touched.lenderList?.[index]?.type &&
            validation.errors.lenderList?.[index]?.type && (
              <FormFeedback>
                {validation.errors.lenderList?.[index]?.type}
              </FormFeedback>
            )}
        </div>
      </td>
      <td data-label="Sanctioned Amount *">
        <Input
          type="text"
          placeholder="Enter amount"
          name={`lender[${index}].sanctionedAmount`}
          id={`lender[${index}].sanctionedAmount`}
          value={validation.values.lenderList[index].sanctionedAmount}
          onChange={(event) => {
            handleInputChange(index, "sanctionedAmount", event.target.value);
          }}
          invalid={
            validation.touched.lenderList?.[index]?.sanctionedAmount &&
              validation.errors.lenderList?.[index]?.sanctionedAmount
              ? true
              : false
          }
        />
        {validation.touched.lenderList?.[index]?.sanctionedAmount &&
          validation.errors.lenderList?.[index]?.sanctionedAmount && (
            <FormFeedback>
              {validation.errors.lenderList?.[index]?.sanctionedAmount}
            </FormFeedback>
          )}
      </td>
      <td data-label="Outstanding Amount *">
        <Input
          type="text"
          placeholder="Enter amount"
          name={`lender[${index}].outstandingAmount`}
          id={`lender[${index}].outstandingAmount`}
          value={validation.values.lenderList[index].outstandingAmount}
          onChange={(event) => {
            handleInputChange(index, "outstandingAmount", event.target.value);
          }}
          invalid={
            validation.touched?.lenderList?.[index]?.outstandingAmount &&
              validation.errors?.lenderList?.[index]?.outstandingAmount
              ? true
              : false
          }
        />
        {validation.touched.lenderList?.[index]?.outstandingAmount &&
          validation.errors.lenderList?.[index]?.outstandingAmount && (
            <FormFeedback>
              {validation.errors.lenderList?.[index]?.outstandingAmount}
            </FormFeedback>
          )}
      </td>
      <td>
        {validation.values?.lenderList?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onClick={() => onDelete(index)}
            style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
          />
        )}
      </td>
    </tr>
  );
};

// BorrowingProfile Component
const BorrowingProfile = (props) => {
  const currentDate = new Date().toISOString().split("T")[0];
  const [selectedOption, setSelectedOption] = useState("No");
  const [rows, setRows] = useState([
    {
      lenderName: "",
      type: "",
      sanctionedAmount: "",
      outstandingAmount: "",
    },
  ]);
  const [borrowingList, setBorrowingList] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isAddBorrowingPermission, setAddBorrowingPermission] = useState(false);
  const [isEditBorrowingPermission, setEditBorrowingPermission] = useState(false);
  const [unitValue, setUnitValues] = useState("crores");
  const [editMode, setEditMode] = useState(false);
  const [lenderOptions, setLenderOptions] = useState([]); 

  const urlParams = new URLSearchParams(window.location.search);
  const [entityId, setEntityId] = useState('');
  const [encodedId, setEncodedId] = useState('');
  const [openCharges, setOpenCharges] = useState([]); 

  // Fetch data
  const getBorrowingData = () => {
    getBorrowingList({ entityId })
      .then((response) => {
        const allBorrowings = response.data?.data || [];
        if (allBorrowings.length > 0) {
          const lenderList = allBorrowings[0].lenderList.map(lender => {
            const matchedOption = lenderOptions.find(option => option.value === lender.lenderName);
            return {
              ...lender,
              lenderLabel: matchedOption ? matchedOption.label : lender.lenderLabel // Ensure lenderLabel is set properly
            };
          });
          allBorrowings[0].lenderList = lenderList;

          const formatedDate = formatDateString1(allBorrowings[0].borrowingAsOf);
          allBorrowings[0].borrowingAsOf = formatedDate;
          setBorrowingList(allBorrowings);
          setRows(lenderList);
          setSelectedOption(allBorrowings[0].outstandingBorrowing ? "Yes" : "No");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
      
  },[ entityId, encodedId])

  const bankValueChange = useAsyncDebounce((value) => {
    fetchBankList(value); // Debounced function to load financiers
  }, 500);

  const fetchBankList = async (search) => {
    try {
      const response = await callfinListSummary({ limit: 10, searchKey: search  });
      const formattedOptions = response.data?.map((option) => ({
        label: option.entityName,
        value: option.id,
      }));
      setLenderOptions((prevOptions) => [...prevOptions, ...formattedOptions]); 
      ; // Ensure this is called after lenderOptions are set
    } catch (error) {
      console.log("Error fetching bank list:", error);
    }
  };
  useEffect(() => {
    validation.setFieldValue("lenderList", rows);
    
  }, [rows]);
  
  useEffect(() => {
    if (entityId) {
      fetchBankList();
      getOpenCharges(entityId)
      getBorrowingData()
    }
    checkPermissions();

  }, [entityId]);

  const checkPermissions = async () => {
    const addBorrowingpermission = await isPermission(
      "borrowing",
      "create_permission"
    );
    const editBorrowingpermission = await isPermission(
      "borrowing",
      "edit_permission"
    );

    setAddBorrowingPermission(addBorrowingpermission);
    setEditBorrowingPermission(editBorrowingpermission);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      borrowingAsOf: borrowingList[0]?.borrowingAsOf || "",
      lenderList: rows || [
        {
          lenderName: "",
          type: "",
          sanctionedAmount: "",
          outstandingAmount: "",
        },
      ],
    },

    validationSchema: Yup.object({
      borrowingAsOf: selectedOption === "Yes" ? Yup.date().required("Borrowing as of is Required") : Yup.date(),
      lenderList: selectedOption === "Yes" ? Yup.array().of(
        Yup.object({
          lenderName: Yup.string().required("Lender name is required"),
          type: Yup.string().required("Lender Type is required"),
          sanctionedAmount: Yup.number()
            .typeError("Sanctioned amount must be a number")
            .required("Sanctioned amount is required")
            .min(0, "Sanctioned amount cannot be negative"),
          outstandingAmount: Yup.number()
            .typeError("Outstanding amount must be a number")
            .min(
              Yup.ref("sanctionedAmount"),
              "Outstanding amount cannot be greater than sanctioned amount"
            )
            .required("Outstanding amount is required")
            .min(0, "Outstanding amount cannot be negative"),
        })
      ) : Yup.array(),
    }),

    onSubmit: (values) => {
      let borrowingProfileObj = {};
      if (selectedOption === "Yes") {
        borrowingProfileObj = {
          borrowingAsOf: values.borrowingAsOf,
          unitValue,
          entityId,
          lenderList: values.lenderList,
          outstandingBorrowing: true
        };
      } else {
        borrowingProfileObj = {
          borrowingAsOf: null,
          unitValue: null,
          entityId,
          lenderList: [{
            lenderName: "",
            type: "",
            sanctionedAmount: "",
            outstandingAmount: "",
          },],
          outstandingBorrowing: false
        };
      }

      for (let elem of values.lenderList) {
        if (+elem.outstandingAmount > +elem.sanctionedAmount) {
          setToastInfo({
            message:
              "Outstanding Amount Can't be greater than sanctioned Amount",
            showToast: true,
            role: "error",
          });
          return;
        }
      }
      if (borrowingList.length === 0) {
        addBorrowing(borrowingProfileObj)
          .then((response) => {
            if ((response.code === 201 && response.status)) {
              setToastInfo({
                message: "Borrowing Saved",
                showToast: true,
                role: "success",
              });
              callAfterSave();
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        borrowingProfileObj.id = borrowingList[0].id;
        editBorrowing(borrowingProfileObj)
          .then((response) => {
            if ((response.code === 201 && response.status)) {
              setToastInfo({
                message: "Borrowing Saved",
                showToast: true,
                role: "success",
              });
              callAfterSave();
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  });

  const handleDelete = (rowIndex) => {
    validation.values.lenderList.splice(rowIndex, 1);
    validation.validateForm();
  };

  const handleItemSelect = (data, value) => {
    data.type = value;
    validation.setFieldValue("type", value);
  };

  const handleUnitValueChange = (e) => {
    setUnitValues(e.target.value);
  };

  const toggleEditMode = () => {
    setEditMode(!editMode);
  };

  const formatLenderName = (type) => {
    if (!type) return '-';
    return type
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(' ');
  };

  const callAfterSave = () => {
    getBorrowingList({ entityId })
      .then((response) => {
        setEditMode(false);
        const allBorrowings = response.data?.data || [];
        if (allBorrowings.length > 0) {
          const formatedDate = formatDateString1(allBorrowings[0].borrowingAsOf);
          allBorrowings[0].borrowingAsOf = formatedDate;
          setBorrowingList(allBorrowings);
          setRows(allBorrowings[0].lenderList);
          setSelectedOption(allBorrowings[0].outstandingBorrowing ? "Yes" : "No");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getOpenCharges = (entityId) => {
    callGetProveBaseApi({ entityId })
      .then((response) => {
        if (response?.status && response?.data?.data?.open_charges?.length > 0) {
          setOpenCharges(response.data.data.open_charges)
        } else {
          setOpenCharges([])
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const truncateText = (text, charLimit) => {
    if (text && text.length > charLimit) {
      const truncated = text.substring(0, charLimit) + "...";
      return truncated;
    }
    return text;
  };
  
 const formatNumberToCroresWithTwoDecimals = (number) => {
  if (number !== null && number !== undefined) {
      const croreValue = number / 10000000;

      // Check if the number has decimals
      const formattedValue = Number.isInteger(croreValue) 
          ? croreValue 
          : croreValue.toFixed(2);

      return `${formattedValue} cr`;
  }
  return '';
}
  return (
    <React.Fragment>
      <Card>
        <CardBody style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
          <Row>
            <Col sm="6" className="mb-2">
              <span className="font-size-16 entityDetailsValue text-success">Open charges</span>{" "}
            </Col>
          </Row>
          <div
            className="mt-2 mb-3 d-flex justify-content-even"
            style={{
              backgroundColor: "#F3F3F3",
              borderRadius: "10px",
              padding: "5px 10px",
              minWidth: "600px",
            }}
          >
            <Col>
              <Label className="d-block">Id</Label>
            </Col>
            <Col>
              <Label className="d-block">Date</Label>
            </Col>
            <Col>
              <Label className="d-block">Holder name</Label>
            </Col>
            <Col>
              <Label className="d-block">Amount</Label>
            </Col>
            <Col>
              <Label className="d-block">Type</Label>
            </Col>
          </div>

          {openCharges.length > 0 ? (
            openCharges.map((openCharge, index) => (
              <React.Fragment key={index}>
                <div
                  className="d-flex justify-content-even"
                  style={{ minWidth: "600px" }} // matches the header minWidth
                >
                  <Col>
                    <span className="mb-0 entityDetailsValue"> {openCharge.id || "-"}</span>
                  </Col>
                  <Col>
                    <span className="mb-0 entityDetailsValue"> {formatDateString(openCharge.date) || "-"}</span>
                  </Col>
                  <Col>
                    <span className="mb-0 entityDetailsValue" id={`holder-name-${index}`}> {truncateText(openCharge.holder_name, 20) || "-"}</span>
                    <UncontrolledTooltip
                        placement="top"
                        target={`holder-name-${index}`}
                    >
                        {openCharge.holder_name}
                    </UncontrolledTooltip>
                                  
                  </Col>
                  <Col>
                    <span className="mb-0 entityDetailsValue"> {openCharge.amount ? '₹' + ' ' + formatNumberToCroresWithTwoDecimals(openCharge.amount) : '-'}</span>
                  </Col>
                  <Col>
                    <span className="mb-0 entityDetailsValue"> {openCharge.type || "-"}</span>
                  </Col>
                </div>
                {openCharges.length - 1 !== index && (
                  <div
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                      borderTop: "1px solid #d7d7d7",
                      minWidth: "600px", // ensures the card can scroll when necessary
                    }}
                  ></div>
                )}
              </React.Fragment>
            ))
          ) : (
            <div className="mt-5">
              <p className="text-center">No open charges records available.</p>
            </div>
          )}
        </CardBody>
      </Card>
      <Card className="p-3">
        {validation.values.lenderList.length > 0 && validation.values.borrowingAsOf !== "" ? (
          <div className="text-end mb-3">
            <div style={{ cursor: "pointer" }}>
              {editMode ?
                <div className="text-sm-end">
                  <Button
                    type="button"
                    color="outline-success"
                    className="btn-rounded mb-2 me-2"
                    onClick={toggleEditMode} 
                  >
                    close
                  </Button>
                </div>
                : <i className="mdi mdi-pencil font-size-16 text-success me-1" onClick={toggleEditMode}><span className="font-size-12">Edit</span></i>}
            </div>
          </div>
        ) : (
          <div className="text-end mb-3">
            <div style={{ cursor: "pointer" }}>
              {editMode ?
                <div className="text-sm-end">
                  <Button
                    type="button"
                    color="outline-success"
                    className="btn-rounded mb-2 me-2"
                    onClick={toggleEditMode} 
                  >
                    close
                  </Button>
                </div>
                : <div className="d-flex justify-content-end">
                  <Button
                    type="button"
                    style={{ backgroundColor: '#21aa47', borderColor: '#21aa47', color: '#fff' }}
                    className="mb-3 me-2"
                    onClick={toggleEditMode} 
                  >
                    <i className="fas fa-plus me-2"></i>
                    <span >
                      {" "}
                      Add Borrower
                    </span>
                  </Button>
                </div>}
              </div>
            </div>
        )}

        {editMode ? (
          <FormikProvider value={validation}>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <Row className="mb-4">
                <Col lg={6} md={6}>
                  <Label
                    htmlFor="horizontal-email-Input"
                    className="col-sm-12 col-form-label"
                  >
                    Do you have any outstanding borrowings?
                  </Label>
                  <div className="d-flex">
                    <div className="form-check ">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios1"
                        value="Yes"
                        checked={selectedOption === 'Yes'}
                        onClick={handleOptionChange}
                        onChange={validation.handleChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleRadios1"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="form-check" style={{ marginLeft: "10px" }}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios2"
                        value="No"
                        checked={selectedOption === 'No'}
                        onClick={handleOptionChange}
                        onChange={validation.handleChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleRadios2"
                      >
                        No
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>

              {selectedOption === "Yes" && (
                <>
                  <Row className="mb-4">
                    <Col lg={3} className="me-5">
                      <Label
                        htmlFor="horizontal-email-Input"
                        className="col-sm-12 col-form-label"
                      >
                        Borrowings as of *
                      </Label>
                      <Input
                        type="date"
                        className="form-control"
                        name="borrowingAsOf"
                        id="borrowingAsOf"
                        max={currentDate}
                        value={validation.values.borrowingAsOf || ""}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          !!(validation.touched.borrowingAsOf &&
                            validation.errors.borrowingAsOf)
                        }
                      />
                      {validation.touched.borrowingAsOf &&
                        validation.errors.borrowingAsOf ? (
                        <FormFeedback type="invalid">
                          {validation.errors.borrowingAsOf}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col lg={2}>
                      <Label
                        htmlFor="horizontal-email-Input"
                        className="col-sm-12 col-form-label"
                      >
                        Enter Unit value
                      </Label>
                      <select
                        className="form-select"
                        onChange={handleUnitValueChange}
                      >
                        <option value="crores">Crores</option>
                        <option value="lakhs">Lakhs</option>
                        <option value="thousands">Thousands</option>
                      </select>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <div className="table-responsive react-table">
                        <Table
                          Table
                          striped
                          bordered
                          hover
                          className="responsive-table"
                          style={{ width: "100%", backgroundColor: "white" }}
                        >
                          <thead className="d-md-table-header-group">
                            <tr>
                              <th>Lender *</th>
                              <th>Type *</th>
                              <th>Sanctioned Amount *</th>
                              <th>Outstanding Amount *</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <FieldArray
                              name="lenderList"
                              render={(arrayHelpers) => (
                                <>
                                  {validation.values.lenderList.map(
                                    (lender, index) => (
                                      <TableRow
                                        key={lender.id}
                                        onDelete={handleDelete}
                                        onItemSelect={handleItemSelect}
                                        index={index}
                                        validation={validation}
                                        lenderOptions={lenderOptions} // pass lenderOptions here
                                        bankValueChange = {bankValueChange}
                                      />
                                    )
                                  )}
                                  <tr>
                                    <td colSpan={5}>
                                      <span
                                        className="text-success"
                                        style={{ cursor: "pointer" }}
                                        onKeyUp={() => { }}
                                        onClick={() => {
                                          arrayHelpers.push({
                                            lenderName: "",
                                            type: "",
                                            sanctionedAmount: "",
                                            outstandingAmount: "",
                                          });
                                        }}
                                      >
                                        <i className="mdi mdi-plus me-1" /> Add
                                        Lender
                                      </span>
                                    </td>
                                  </tr>
                                </>
                              )}
                            />
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </>
              )}

              <Row>
                <Col>
                  <div className="text-end">
                    {(borrowingList.length === 0 ? isAddBorrowingPermission : isEditBorrowingPermission) && <button type="submit" className="btn btn-success">
                      Save
                    </button>}
                  </div>
                </Col>
              </Row>
            </Form>
          </FormikProvider>
        ) : (
          <div>
            {validation.values.borrowingAsOf !== "" ? (
              <Row>
                <Col sm="6" className="mb-2">
                  <span className="font-size-16 entityDetailsValue text-success">Borrowing As Of: {formatDateString(validation.values.borrowingAsOf)}</span>{" "}
                </Col>
                <Col sm="6" className="mb-2">
                  <span className="font-size-16 entityDetailsValue text-success">Unit Value: {unitValue}</span>
                </Col>
              </Row>
            ) : (null)}
            {validation.values.lenderList.length > 0 && validation.values.borrowingAsOf !== "" ? (
              rows?.map((borrower, index) => (
                <React.Fragment key={index}>
                  <Row className="mt-3">
                    <Col sm="6" md="4" lg="3" className="mb-2 mt-2">
                      <Label className="d-block entityDetails">Lender Name</Label>
                      <span className="mb-0 entityDetailsValue"> {borrower.lenderLabel || '-'}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-2 mt-2">
                      <Label className="d-block entityDetails">Lender Type</Label>
                      <span className="mb-0 entityDetailsValue">{formatLenderName(borrower.type) || '-'}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-2 mt-2">
                      <Label className="d-block entityDetails">Sanctioned Amount</Label>
                      <span className="mb-0 entityDetailsValue">₹ {borrower.sanctionedAmount || '-'}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-2 mt-2">
                      <Label className="d-block entityDetails">Outstanding Amount</Label>
                      <span className="mb-0 entityDetailsValue">₹ {borrower.outstandingAmount || '-'}</span>
                    </Col>
                  </Row>

                  <div style={{ marginTop: '3%', borderTop: '1px solid #d7d7d7' }}></div>
                </React.Fragment>
              ))
            ) : (
              <div className="mt-5">
                <p className="text-center">No Borrowing Profile records available.</p>
              </div>
            )}
          </div>
        )}
      </Card>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default BorrowingProfile;

export function formatDateString(date) {
  if (date === null || date === undefined) {
    return null;
  }
  const inputDateString = date;
  const inputDate = new Date(inputDateString);
  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, "0");
  const day = String(inputDate.getDate()).padStart(2, "0");

  const formattedDateString = `${day}-${month}-${year}`;
  return formattedDateString;
}

export function formatDateString1(date) {
  if (date === null || date === undefined) {
    return null;
  }
  const inputDateString = date;
  const inputDate = new Date(inputDateString);
  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, "0");
  const day = String(inputDate.getDate()).padStart(2, "0");

  const formattedDateString = `${year}-${month}-${day}`;
  return formattedDateString;
}
